module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Далее","track":"Next"}}